module.exports = __webpack_public_path__ + "static/media/croffles.23d2c2d1.jpeg";